<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [id]="id"
    [errorMsg]="errorMsg"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <med-form-thesaurus-base-complex
            [id]="id"
            [label]="label"
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [thesaurusDefDottedKey]="thesaurusDefDottedKey"
            [recordIds]="recordIds"
            [enableSuggestions]="enableSuggestions"
            [multiple]="multiple"
            [selectValuesLabel]="selectValuesLabel"
            [indeterminateMsg]="indeterminateMsg"
            [placeholderMsg]="placeholderMsg"
            [maxValuesMsg]="maxValuesMsg"
            [suggestionExistsErrorMsg]="suggestionExistsErrorMsg"
            [isDisabled]="control.disabled"
            [disabledMsg]="disabledMsg"
            [initialSuggestions]="initialSuggestions"
            [activeRecord]="activeRecord"
        ></med-form-thesaurus-base-complex>
    </ng-template>

    <ng-template #simple>
        <med-form-thesaurus-base
            [id]="id"
            [label]="label"
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [thesaurusDefDottedKey]="thesaurusDefDottedKey"
            [recordIds]="recordIds"
            [enableSuggestions]="enableSuggestions"
            [multiple]="multiple"
            [selectValuesLabel]="selectValuesLabel"
            [indeterminateMsg]="indeterminateMsg"
            [placeholderMsg]="placeholderMsg"
            [maxValuesMsg]="maxValuesMsg"
            [suggestionExistsErrorMsg]="suggestionExistsErrorMsg"
            [disabledMsg]="disabledMsg"
            [initialSuggestions]="initialSuggestions"
            [activeRecord]="activeRecord"
        ></med-form-thesaurus-base>
    </ng-template>
</sh-form-group>
